export default __webpack_public_path__ + "static/media/junk9.8e886f8a.svg";